module.exports = __webpack_public_path__ + "images/psp/College/5x10.svg";